import React from "react";
import { Oval } from "react-loader-spinner";
import { TiTick } from "react-icons/ti";

const FlowLoadingPopup = ({ data }) => {
  let steps = Object.entries(data).map(([key, value]) => ({
    key,
    ...value,
  }));

  return (
    <div className="min-w-[100vw] w-full h-screen flex justify-center items-center bg-[#241b4795] backdrop-blur-md fixed top-0 left-0 z-50 ">
      <div className="w-[95%] sm:w-[420px] pt-6 pb-4 px-5 flex flex-col justify-center items-center rounded-2xl bg-custom-gray-300 ">
        <span className="text-3xl abel-font mb-7 ">Steps</span>
        {steps
          .filter((item) => !item?.hidden)
          .sort((a, b) => a.step - b.step)
          .map((step, index) => (
            <div
              key={"step_" + index}
              className="w-full flex items-center mb-4"
            >
              <span className="min-w-[48px] w-12 h-12 flex justify-center items-center">
                {step.status === "loading" ? (
                  <Oval
                    height={35}
                    width={35}
                    color="#8538FF"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                    ariaLabel="oval-loading"
                    secondaryColor="#8538FF"
                    strokeWidth={2}
                    strokeWidthSecondary={2}
                  />
                ) : step.status === "success" ? (
                  <TiTick size={33} color="#1ED760" />
                ) : null}
              </span>
              <div className="flex flex-col ml-4 ">
                <span className="text-lg sm:text-xl font-bold">{step.text}</span>{" "}
                <p className="text-sm text-custom-gray-600 mt-1">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default FlowLoadingPopup;
